import React from "react";
import "./Work.css";
const Work = () => {
  const data = [
    {
      id: 1,

      img: require("../../Assets/show-img.png"),
      title: "Quick Registration",
      description: "Sign up with basic details.",
    },
    {
      id: 2,
      img: require("../../Assets/img16.png"),

      title: "Credential Verification",
      description: "We review your certifications and licenses.",
    },
    {
      id: 3,
      img: require("../../Assets/img17.png"),
      title: "Onboarding & Training",
      description: "Learn our platform and processes.",
    },
    {
      id: 4,
      img: require("../../Assets/img18.png"),
      title: "Start Accepting Patients",
      description: "Get booked for services directly through Wihan.",
    },
  ];
  return (
    <>
      <div className="join-section">
        <h1 className="heading-h1 mb-40">How It Works</h1>
        <div className="work-card">
          {data?.map((item) => {
            return (
              <div className="work-card-content" key={item.id}>
                <img src={item?.img} alt="" className="work-img" />
                <div className="work-overlay">
                  <h6 className="work-text">{item?.title}</h6>
                  <p className="work-description">{item?.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Work;
